import {Injectable} from '@angular/core';
import {Profile} from "@model/profile";
import {HttpClient} from "@angular/common/http";
import {AppConfigurationService} from '../shared/app-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  private readonly _apiUrl: string;

  constructor(private _http: HttpClient, private _appConfig: AppConfigurationService) {
    this._apiUrl = this._appConfig.getConfig().apiUrl + '/profiles';
  }

  getProfiles() {
    return this._http.get<Profile[]>(this._apiUrl);
  }

}
